import { toast } from 'react-toastify';
import { axiosCaller } from '../utils/apiCaller';
import { wrap } from './generalActions';
import { translatedText } from '../components/TranslatedText';

/**
 * Audit + restore actions for the tenant-side client cascade-delete workflow.
 *
 * Routes (all gated by tenant `superAdmin` permission):
 *   GET  client-deletions[?status=]    → audit list, scoped to company
 *   GET  client-deletions/{id}         → single record
 *   POST client-deletions/{id}/restore → reverse the cascade (client + linked projects)
 *
 * The delete itself goes through the regular DELETE /clients/{id} route (handled by
 * ClientService::deleteClient, which now delegates the cascade to
 * ClientDeletionService).
 */

/**
 * Read-only cascade preview for a client. Returns the manifest of what
 * forceDeleteClient WOULD soft-delete, so the confirm modal can show the
 * user "this will delete X measures, Y offers, Z agreements…" BEFORE they
 * pull the trigger. Mirrors getProjectDeletionPreview.
 *
 * Response shape:
 *   { data: { client_id, affected_counts: {[table]: number}, active_project_ids: number[], existing_project_deletion_ids: number[] } }
 */
export const getClientDeletionPreview = (clientId: number) => wrap(async (_dispatch: any) => {
    try {
        return await axiosCaller('GET', `clients/${clientId}/deletion-preview`);
    } catch (err) {
        toast.error(translatedText({ id: 'somethingWentWrongAlt', defaultMessage: 'Diqka shkoi gabim!' }));
    }
}, 'GET_CLIENT_DELETION_PREVIEW_ERROR');

export const getClientDeletions = (filters: { status?: 'active' | 'restored'; page?: number; perPage?: number } = {}) =>
    wrap(async (_dispatch: any) => {
        try {
            const qs: string[] = [];
            if (filters.status) qs.push(`status=${filters.status}`);
            if (filters.page) qs.push(`page=${filters.page}`);
            if (filters.perPage) qs.push(`per_page=${filters.perPage}`);
            const suffix = qs.length ? `?${qs.join('&')}` : '';
            return await axiosCaller('GET', `client-deletions${suffix}`);
        } catch (err) {
            toast.error(translatedText({ id: 'somethingWentWrongAlt', defaultMessage: 'Diqka shkoi gabim!' }));
        }
    }, 'GET_CLIENT_DELETIONS_ERROR');

export const getClientDeletion = (recordId: number) => wrap(async (_dispatch: any) => {
    try {
        return await axiosCaller('GET', `client-deletions/${recordId}`);
    } catch (err) {
        toast.error(translatedText({ id: 'somethingWentWrongAlt', defaultMessage: 'Diqka shkoi gabim!' }));
    }
}, 'GET_CLIENT_DELETION_ERROR');

export const restoreClientDeletion = (recordId: number) => wrap(async (_dispatch: any) => {
    try {
        return await axiosCaller('POST', `client-deletions/${recordId}/restore`);
    } catch (err) {
        toast.error(translatedText({ id: 'somethingWentWrongAlt', defaultMessage: 'Diqka shkoi gabim!' }));
    }
}, 'RESTORE_CLIENT_DELETION_ERROR');
